/**
 * Copyright (C) 2026 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import ActionCreator from '../action-creator';
import { GroundStationType } from '../../shared/entities/haloNet';

export interface RequestHaloNetGroundStationAvailabilityPayload {
  type: GroundStationType;
  svName?: string;
}

export const ActionCreators = {
  RequestHaloNetGroundStations: new ActionCreator<'RequestHaloNetGroundStations', any>('RequestHaloNetGroundStations'),
  ReceivedHaloNetGroundStationsSuccess: new ActionCreator<'ReceivedHaloNetGroundStationsSuccess', any>(
    'ReceivedHaloNetGroundStationsSuccess',
  ),
  ReceivedHaloNetGroundStationsError: new ActionCreator<'ReceivedHaloNetGroundStationsError', any>(
    'ReceivedHaloNetGroundStationsError',
  ),

  RequestHaloNetGroundStationAvailability: new ActionCreator<
    'RequestHaloNetGroundStationAvailability',
    RequestHaloNetGroundStationAvailabilityPayload
  >('RequestHaloNetGroundStationAvailability'),
  ReceivedHaloNetGroundStationAvailabilitySuccess: new ActionCreator<
    'ReceivedHaloNetGroundStationAvailabilitySuccess',
    any
  >('ReceivedHaloNetGroundStationAvailabilitySuccess'),
  ReceivedHaloNetGroundStationAvailabilityError: new ActionCreator<
    'ReceivedHaloNetGroundStationAvailabilityError',
    any
  >('ReceivedHaloNetGroundStationAvailabilityError'),

  RequestHaloNetGroundStationReservations: new ActionCreator<'RequestHaloNetGroundStationReservations', any>(
    'RequestHaloNetGroundStationReservations',
  ),
  ReceivedHaloNetGroundStationReservationsSuccess: new ActionCreator<
    'ReceivedHaloNetGroundStationReservationsSuccess',
    any
  >('ReceivedHaloNetGroundStationReservationsSuccess'),
  ReceivedHaloNetGroundStationReservationsError: new ActionCreator<
    'ReceivedHaloNetGroundStationReservationsError',
    any
  >('ReceivedHaloNetGroundStationReservationsError'),

  ToggleHaloNetGroundStationVisibility: new ActionCreator<'ToggleHaloNetGroundStationVisibility', string>(
    'ToggleHaloNetGroundStationVisibility',
  ),
  ToggleAllHaloNetGroundStationsVisibility: new ActionCreator<'ToggleAllHaloNetGroundStationsVisibility', boolean>(
    'ToggleAllHaloNetGroundStationsVisibility',
  ),
};

type ActionCreatorMap = typeof ActionCreators;
export type Action = ReturnType<ActionCreatorMap[keyof ActionCreatorMap]['create']>;

export function requestHaloNetGroundStations() {
  return ActionCreators.RequestHaloNetGroundStations.create();
}

export function requestHaloNetGroundStationAvailability(payload: RequestHaloNetGroundStationAvailabilityPayload) {
  return ActionCreators.RequestHaloNetGroundStationAvailability.create(payload);
}

export function requestHaloNetGroundStationReservations() {
  return ActionCreators.RequestHaloNetGroundStationReservations.create();
}

export function toggleHaloNetGroundStation(siteDesignation: string) {
  return ActionCreators.ToggleHaloNetGroundStationVisibility.create(siteDesignation);
}

export function toggleAllHaloNetGroundStations(isVisible: boolean) {
  return ActionCreators.ToggleAllHaloNetGroundStationsVisibility.create(isVisible);
}
